import ArbokApi from "./requests/arbok-api";
export default (config) => {
    const desktopNumber = Math.floor(Math.random() * (10 - 1 + 1)) + 1;
    const key = "desktop";
    return ArbokApi.getInstance().request.put(`/originals/chat/${key}-${desktopNumber}`, config === null || config === void 0 ? void 0 : config.data, {
        onUploadProgress: (progressEvent) => {
            const total = (progressEvent === null || progressEvent === void 0 ? void 0 : progressEvent.total) ? progressEvent.total : 0;
            const progress = (progressEvent.loaded / total) * 50;
            config === null || config === void 0 ? void 0 : config.onUploadProgress(progress);
        },
        onDownloadProgress: (progressEvent) => {
            const total = (progressEvent === null || progressEvent === void 0 ? void 0 : progressEvent.total) ? progressEvent.total : 0;
            const progress = 50 + (progressEvent.loaded / total) * 50;
            config === null || config === void 0 ? void 0 : config.onDownloadProgress(progress);
        },
        params: Object.assign(Object.assign({}, config === null || config === void 0 ? void 0 : config.params), { async: 1 }),
    });
};
